import axios from 'axios'
import store from '@/store/store'


// 添加请求拦截器
axios.interceptors.request.use(function (config) {
   if(config.headers['Content-Type']){
      if(config.headers['Content-Type'].indexOf('application/json')==0){
        config.transformRequest = [function (data) {
          return JSON.stringify(data);
        }]
      }else{
        config.transformRequest = [function (data) {
          return data;
        }]
      }
   }
    // 在发送请求之前做些什么
    return config;

  }, function (error) {
    // 对请求错误做些什么
    alert(error);
    return Promise.reject(error);
  });

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么

    if(response.data.errorCode == -1002){
      //alert(response.data.message);
      store.commit('logout');
      window.location.href="login.html";
      //router.push({path: '/login'})
      //return ;
    }
    // 1008 没有权限
    if(response.data.errorCode === -1008){
        alert('No permission');
    }
    return response.data;
  }, function (error) {
    // 对响应错误做点什么
    alert(error);
    return Promise.reject(error);
  });


axios.defaults.transformRequest = [function (data) {
    // 对 data 进行任意转换处理
    let ret = ''
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret;
  }]


axios.defaults.baseURL = '/backend';

export default axios


// WEBPACK FOOTER //
// ./src/views/main/request.js